import { Component, AfterViewInit } from '@angular/core';
declare var $: any;



@Component({
    selector: 'calendario-right',
    templateUrl: 'calendario-right.template.html',

})

export class CalendarioRightComponent implements AfterViewInit {
    constructor() { }
    ngAfterViewInit() {

        // Initialize datepicker with it
        $('.datepicker-here').datepicker({
            language: 'es'
        })

    }
}
